import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({
  subComponent: state.statsbar.activeComponent,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageOrganizationList
 * @description
 * # manageOrganizationList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('manageOrganizationList', ($ngRedux, $scope, $rootScope, $location, $route) => {
    if (!$scope.isAdminUser) {
      $location.path('/');
    }

    $scope.takeAction = (id) => {
      if (id === 'create-organization') {
        $scope.onCreateOrganization();
      } else if (id) {
        $scope.onEditOrganization({ organizationId: id });
      }
    };

    $scope.processParams = () =>
      new Promise((resolve) => {
        const { organizationId } = $route.current.params;
        $scope.takeAction(organizationId);
        resolve(true);
      });

    $scope.init = () => {
      $rootScope.previousRoute = $rootScope.routes.organization;
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.processParams();
    };

    $scope.table = {
      name: 'Manage Organizations',
      options: {
        endpoint: '/2.0/organizations/',
        endpoint_data_key: 'organizations',
        per_page_options: [15, 25, 50, 100, 200],
        records_per_page: 15,
        row_style: 'standard',
        scale_up: false,
        search_key: 'Organizations',
        search_required: true,
      },
      actions: [
        {
          name: 'Create Organization',
          link: '#',
          onclick: () => {
            $scope.onCreateOrganization();
          },
          order: 0,
          superuser: false,
        },
      ],
      columns: [
        {
          name: 'Date Created',
          options: {
            content: '{{ record.date_created }}',
            class: '',
          },
        },
        {
          name: 'Date Updated',
          options: {
            content: '{{ record.date_updated }}',
            class: '',
          },
        },
        {
          name: 'Organization Name',
          options: {
            content: '{{ record.name }}',
            class: '',
          },
        },
        {
          name: 'NARC ID',
          options: {
            content: '{{ record.narc_id }}',
            class: '',
          },
        },
        {
          name: 'Address',
          options: {
            content:
              '<span ng-if="record.address_information.address_1">{{ record.address_information.address_1 }}</span><br ng-if="record.address_information.address_1" />' +
              '<span ng-if="record.address_information.address_2">{{ record.address_information.address_2 }}</span><br ng-if="record.address_information.address_2" />' +
              '<span ng-if="record.address_information.city">{{ record.address_information.city }}, </span><span ng-if="record.address_information.state">{{ record.address_information.state }} </span>' +
              '<span ng-if="record.address_information.zip">{{ record.address_information.zip }} </span><span ng-if="record.address_information.country">{{ record.address_information.country }}</span>',
            class: '',
          },
        },
        {
          name: 'Directory Type(s)',
          options: {
            content:
              '<ul><li ng-repeat="directory_type in record.directory_types">{{ directory_type.name }}</li></ul>',
            class: 'list-column',
          },
        },
        {
          name: 'Action',
          options: {
            content:
              '<a href="#" ng-click="onEditOrganization({organizationId: record.id})">Edit Organization</a>',
            class: 'td-action',
          },
        },
      ],
      filters: [
        {
          name: 'Directory Type',
          type: 'multiple_choice',
          options: {
            choices: {},
            choices_endpoint: '/2.0/organizations/directory-types/?order=name',
            choices_endpoint_data_key: 'directory-types',
            class: 'application-filter',
            name_attribute: 'name',
            no_selected_parameter: 'none',
            query_string_parameter: 'directory_type',
            select_all: true,
          },
        },
        {
          name: 'Application Subscription',
          type: 'multiple_choice',
          options: {
            choices: {},
            choices_endpoint: '/2.0/applications/',
            choices_endpoint_data_key: 'applications',
            class: 'application-filter',
            name_attribute: 'name',
            no_selected_parameter: 'none',
            query_string_parameter: 'application_subscription',
            select_all: true,
          },
        },
      ],
      sort_options: {
        date_created: {
          state: false,
          value: '-1',
          title: 'Date Created',
          order: 0,
        },
        date_updated: {
          state: true,
          value: '-1',
          title: 'Date Updated',
          order: 1,
        },
        mdm_id: {
          state: false,
          value: '1',
          title: 'Narc ID',
          order: 2,
        },
      },
    };

    $scope.init();

    $scope.$on('$destroy', $scope.unsubscribe);
  });
